import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEmail2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="email-2, envelope"><path d="M21.25 4.75H22V4H21.25V4.75ZM21.25 19.25V20H22V19.25H21.25ZM2.75 4.75V4H2V4.75H2.75ZM2.75 19.25H2V20H2.75V19.25ZM21.25 4.75H20.5V19.25H21.25H22V4.75H21.25ZM2.75 4.75V5.5H21.25V4.75V4H2.75V4.75ZM2.75 19.25H3.5V4.75H2.75H2V19.25H2.75ZM21.25 19.25V18.5H2.75V19.25V20H21.25V19.25Z" fill="currentColor"/><path d="M3 8.12598L12 12.6607L21 8.12598" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconEmail2;
